export default __webpack_public_path__ + "static/media/Flag_of_Sweden.1013cca8.svg";